/**
 * GrainOverlay — fixed SVG turbulence texture overlaid at 4.5 % opacity.
 * Adds the subtle film-grain that separates premium dark sites from flat ones.
 */
export function GrainOverlay() {
  return (
    <svg id="grain" xmlns="http://www.w3.org/2000/svg"
      style={{ position:'fixed', inset:0, zIndex:300, pointerEvents:'none',
               opacity:.045, mixBlendMode:'overlay', width:'100%', height:'100%' }}>
      <filter id="grainNoise">
        <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch"/>
      </filter>
      <rect width="100%" height="100%" filter="url(#grainNoise)"/>
    </svg>
  )
}
